<template>
  <div class="banner" v-if="bannerStatus">
    <swiper ref="bannerSwiper" :options="swiperOption" class="mySwiper">
      <swiper-slide
        v-for="(item, index) in list"
        :key="index"
        class="slide">
        <div class="game">
          <!-- // 이미지 경로 확정 후 작업 필요 -->
          <img :src="imageSrc('event_banner_temp.png')"/>
          <!--
          <div class="info">
            <p class="title">{{item.subject}}</p>
            <p v-if="item.dateLimit">{{item.startDate}}~{{item.endDate}}</p>
          </div>
          <div class="emblem">
            <img :src="getEmblem(item.home_team)" alt="">
          </div>
          <div class="emblem">
            <img :src="getEmblem(item.away_team)" alt="">
          </div>
          -->
        </div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
import {Swiper, SwiperSlide} from 'vue-awesome-swiper';
import 'swiper/css/swiper.css'
import {getEmblem} from '@/lib';
import dayjs from 'dayjs';
export default {
  name : 'Banner',
  components: {
    Swiper,
    SwiperSlide
  },
  mounted () {
    this.init()
  },
  data() {
    return{
      swiperOption: {
        slidesPerView: 1,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        }
      },
      swiperPause: false,
      list: [],
      bannerStatus: false
    }
  },
  methods: {
    getEmblem,
    async init () {
      const swiper = this.$refs.bannerSwiper
      if (swiper) {
        swiper.$swiper.activeIndex = 1
      }

      const {data} = await this.$http.get('/main/slide_middle')
      if (data.success && data.data.length > 0) {
        this.bannerStatus = true
        this.list = data.data
        this.list.map(item => {
          // 이미지 경로 확정 후 작업 필요
          // item.slide_img = 'https://www.dragons.co.kr/' + item.slide_img
          item.dateLimit = false
          item.startDate = ''
          item.endDate = ''
          if(item.reserve_start_date && item.reserve_end_date) {
            item.dateLimit = true
            item.startDate = dayjs(item.reserve_start_date).format('MM-DD')
            item.endDate = dayjs(item.reserve_end_date).format('MM-DD')
          }
        })
      }
    },
    imageSrc(imgSrc) {
      return require('@/assets/img/banner/'+imgSrc);
    }
  }
}
</script>
